import * as React from 'react';
import { Component } from 'react';

interface Props {
    children?: React.ReactNode;
}

interface State {
   
}

export default class NoLayout extends Component<Props, State> {
    constructor(props:any) {
        super(props);
        this.state = {
         
        };
    }

    componentDidMount() {        
        require('../adminassets/vendor/fontawesome-free/css/all.min.css');
        // require('../adminassets/vendor/bootstrap/css/bootstrap.min.css');
        // require('../adminassets/css/admin-Styles.css');  
        require('../assets/styles/style.css');
      }

    public render() {
        return (
        <div>
            {this.props.children}              
</div>              

           );
    }
}


